import { cardItems } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑团队每日精选高分好剧，品质保证，部部都值得追
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 flex flex-col"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2 py-1 rounded-md bg-accent-500/90 text-background-50 text-xs font-bold whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute bottom-2.5 left-2.5">
                  <span className="px-2 py-0.5 rounded-md bg-background-950/60 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2 whitespace-nowrap">
                  {item.category}
                </p>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1 line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}